import { useMutation } from "@tanstack/react-query";
import { t } from "i18next";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions, useRefetchQuery } from "libs/reactQuery";
import toast from "react-hot-toast";

import { UsageGuide } from "../../productUsageGuides.types";
import { requestUpsertUsageGuide } from "./upsertUsageGuide.request";
import { UpsertUsageGuideRequestBody } from "./upsertUsageGuide.types";

const useUpsertUsageGuide = (
  options?: MutationOptions<
    UsageGuide,
    ApiServiceError<ApiError>,
    UpsertUsageGuideRequestBody
  >
) => {
  const refetchUsageGuides = useRefetchQuery(["product-usage-guides"]);

  return useMutation({
    mutationFn: requestUpsertUsageGuide,
    ...options,
    onSuccess: (data, variables, context) => {
      void refetchUsageGuides();
      toast.success(t("Guide saved successfully"));
      options?.onSuccess?.(data, variables, context);
    }
  });
};

export default useUpsertUsageGuide;
